import { ENTITY_NAMES } from "@miplatform/constants";

export const orderCardConfig = [
  {
    label: "Scheduled Date",
    fieldKey: "approvedStartDate",
    dependentType: "orders",
    isSelected: true,
    displayOrder: 1,
    area: "card",
  },
  {
    label: "Start Date",
    fieldKey: "inProgressStartedDate",
    dependentType: "orders",
    isSelected: true,
    displayOrder: 2,
    area: "card",
  },
  {
    label: "Complete Date",
    fieldKey: "completeDate",
    dependentType: "orders",
    isSelected: true,
    displayOrder: 3,
    area: "card",
  },
];

export const orderHoverCardConfig = [
  {
    label: "Job Number",
    fieldKey: "jobNumber",
    dependentType: "orders",
    isSelected: true,
    displayOrder: 1,
    area: "hover-card",
  },
  {
    label: `${ENTITY_NAMES.ORDER_TEMPLATE} Name`,
    fieldKey: "orderTemplateName",
    dependentType: "orders",
    isSelected: true,
    displayOrder: 2,
    area: "hover-card",
  },
  {
    label: `${ENTITY_NAMES.ORDER_TEMPLATE} Short Name`,
    fieldKey: "orderTemplateShortName",
    dependentType: "orders",
    isSelected: true,
    displayOrder: 3,
    area: "hover-card",
  },
  {
    label: `${ENTITY_NAMES.ORDER_TEMPLATE} Color`,
    fieldKey: "orderTemplateColor",
    dependentType: "orders",
    isSelected: true,
    displayOrder: 4,
    area: "hover-card",
  },
  {
    label: `${ENTITY_NAMES.ORDER_TEMPLATE} Follow Up Default Offset Hours`,
    fieldKey: "orderTemplateFollowUpDefaultOffsetHours",
    dependentType: "orders",
    isSelected: true,
    displayOrder: 5,
    area: "hover-card",
  },
  {
    label: "Requires Approval",
    fieldKey: "requiresApproval",
    dependentType: "orders",
    isSelected: true,
    displayOrder: 6,
    area: "hover-card",
  },
  {
    label: "Order Status",
    fieldKey: "orderStatus",
    dependentType: "orders",
    isSelected: true,
    displayOrder: 7,
    area: "hover-card",
  },
  {
    label: "Void Date",
    fieldKey: "voidDate",
    dependentType: "orders",
    isSelected: true,
    displayOrder: 8,
    area: "hover-card",
  },
  {
    label: "Account Name",
    fieldKey: "account.name",
    dependentType: "orders",
    isSelected: true,
    displayOrder: 9,
    area: "hover-card",
  },
  {
    label: "Home Builder Name",
    fieldKey: "home.builderName",
    dependentType: "orders",
    isSelected: true,
    displayOrder: 10,
    area: "hover-card",
  },
];
